import { decode, encode } from 'base64-arraybuffer';
const subtle = crypto.subtle;
const textEncoder = new TextEncoder();
export async function createInitiatorConfig() {
    const key = await subtle.generateKey({ name: 'HMAC', hash: { name: 'SHA-256' } }, true, ['sign', 'verify']);
    const keyBytes = await subtle.exportKey('raw', key);
    const peerAuth = await SharedSecretPeerAuth.create(keyBytes);
    // For shared secret keys, we use the hash of the key as the pairing ID:
    const pairingIdBytes = await subtle.digest('SHA-256', keyBytes);
    const pairingId = encode(pairingIdBytes);
    const peerConfig = {
        pairingId,
        peerAuth,
        role: 'initiator',
    };
    return {
        secretBase64: encode(keyBytes),
        peerConfig,
    };
}
export async function createInitiatorConfigWithSecret(sharedKeyBase64) {
    const keyBytes = decode(sharedKeyBase64);
    const peerAuth = await SharedSecretPeerAuth.create(keyBytes);
    const pairingIdBytes = await subtle.digest('SHA-256', keyBytes);
    const pairingId = encode(pairingIdBytes);
    return {
        pairingId,
        peerAuth,
        role: 'initiator',
    };
}
export async function createResponderConfig(sharedKeyBase64) {
    const keyBytes = decode(sharedKeyBase64);
    // For shared secret keys, we use the hash of the key as the pairing ID:
    const pairingIdBytes = await subtle.digest('SHA-256', keyBytes);
    const pairingId = encode(pairingIdBytes);
    const peerAuth = await SharedSecretPeerAuth.create(keyBytes);
    return {
        pairingId,
        peerAuth,
        role: 'responder',
    };
}
export class SharedSecretPeerAuth {
    sharedKey;
    /**
     * Creates an instance of PeerAuth where each peer knows the same shared
     * secret, and signs/verifies eachothers' messages with it.
     *
     * @param sharedSecret raw bytes of the shared signing secret.
     */
    static async create(sharedSecret) {
        const sharedKey = await subtle.importKey('raw', sharedSecret, {
            name: 'HMAC',
            hash: 'SHA-256'
        }, false, ['sign', 'verify']);
        return new SharedSecretPeerAuth(sharedKey);
    }
    constructor(sharedKey) {
        this.sharedKey = sharedKey;
    }
    async signMessage(message) {
        const signature = await subtle.sign('HMAC', this.sharedKey, textEncoder.encode(message));
        return encode(signature);
    }
    async verifyMessage(base64Signature, message) {
        return await subtle.verify('HMAC', this.sharedKey, decode(base64Signature), textEncoder.encode(message));
    }
}
